import { render, staticRenderFns } from "./ItemAcquire.vue?vue&type=template&id=72a3e28e&scoped=true&"
import script from "./ItemAcquire.vue?vue&type=script&lang=js&"
export * from "./ItemAcquire.vue?vue&type=script&lang=js&"
import style0 from "./ItemAcquire.vue?vue&type=style&index=0&id=72a3e28e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3e28e",
  null
  
)

export default component.exports